import "../CSS/diplome.css";

import Seo from "../components/Seo";


function DiplomePage() {

    const diplome = [

        {
            titel: "Dipl. Techniker HF Maschinenbau",
            bild: "/Diplome/maschinenbau.jpg",
            datei: "/Diplome/Diplom Maschinenbau.pdf"
        },

        {
            titel: "Dipl. Techniker HF Betriebstechnik",
            bild: "/Diplome/betriebstechniker.jpg",
            datei: "/Diplome/Diplom Betriebtechniker HF.pdf"
        },

        {
            titel: "Qualitätsfachmann",
            bild: "/Diplome/qualitätsfachmann.jpg",
            datei: "/Diplome/Diplom Qulitätsfachmann.pdf"
        },

        {
            titel: "TIA Serv 1",
            bild: "/Diplome/sps.jpg",
            datei: "/Diplome/Diplom TIA Serv1.pdf"
        }

    ];


    return (

        <>

            <Seo
                title="Diplome"
                description="Diplome und Abschlüsse von Ivan Jörg aus den Bereichen Maschinenbau, Betriebstechnik, Qualitätsmanagement und Automatisierung."
                canonical="https://www.irj.ch/diplome"
            />


            <div className="intro">

                <p>
                    Hier findest Du eine Auswahl meiner Diplome.
                </p>

            </div>


            <main>

                <div className="karten-container">

                    {
                        diplome.map(
                            (diplom, index) => (

                                <article
                                    className="content-card"
                                    key={index}
                                >

                                    <div className="card-bild">

                                        <img
                                            src={diplom.bild}
                                            alt={diplom.titel}
                                        />

                                    </div>


                                    <h2>
                                        {diplom.titel}
                                    </h2>


                                    <a
                                        className="card-button"
                                        href={diplom.datei}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Diplom öffnen
                                    </a>

                                </article>

                            )
                        )
                    }

                </div>

            </main>

        </>

    );
}


export default DiplomePage;
